// Removes a signed-in teacher's cached work from this browser at logout.
//
// School computers are shared: whatever stays in localStorage after logout can be read
// by the next person at the same desk. Settings that are not work (language, theme,
// voice, "tour seen") are kept.

import { clearAllToolDrafts } from './toolDrafts';

// Shared keys written by older versions of the app (one copy for everyone, not per user).
// Nothing reads them any more; they are removed so old copies do not linger.
export const LEGACY_SHARED_KEYS = ['homework_autosave', 'corrector_autosave'];

// The book-upload jobs list kept by useOcrJobs.
export const ocrJobsKey = (userId) => `ocr_jobs::${userId || 'guest'}`;

const remove = (key) => {
  try { window.localStorage.removeItem(key); } catch (e) { /* storage blocked: nothing saved */ }
};

/**
 * @param {string} userId          the teacher who is signing out (or a guest id)
 * @param {string[]} perUserKeys   base keys saved as `${key}_${userId}`
 */
export function clearUserBrowserData(userId, perUserKeys = []) {
  if (userId) {
    perUserKeys.forEach((key) => remove(`${key}_${userId}`));
    remove(ocrJobsKey(userId));
  }
  LEGACY_SHARED_KEYS.forEach(remove);
  // Content generator drafts (sessionStorage), for every user, and requests still running.
  clearAllToolDrafts();
}
